export default __webpack_public_path__ + "static/granola_product-b07cd94abeba0fadb54e7f070dcc321a.jpg";